import { render } from "./MembersCardRow.vue?vue&type=template&id=bc8da5e0"
import script from "./MembersCardRow.vue?vue&type=script&lang=js"
export * from "./MembersCardRow.vue?vue&type=script&lang=js"

import "./MembersCardRow.vue?vue&type=style&index=0&id=bc8da5e0&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__